import { Send } from "lucide-react";
import { REGISTER_URL, TELEGRAM_URL } from "@/data/site";

export default function StickyBar() {
  return (
    <div
      data-testid="mobile-sticky-bar"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#07090E]/95 backdrop-blur-2xl md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-2 gap-2.5 p-3">
        <a
          href={REGISTER_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-sticky-register-btn"
          className="flex h-11 items-center justify-center rounded-full bg-[#F0B429] text-sm font-bold text-[#07090E]"
        >
          Daftar Sekarang
        </a>
        <a
          href={TELEGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => window.fbq && window.fbq("trackCustom", "TelegramClick")}
          data-testid="mobile-sticky-telegram-btn"
          className="flex h-11 items-center justify-center gap-2 rounded-full border border-[#00F2B6]/40 bg-[#14232B] text-sm font-bold text-[#00F2B6]"
        >
          <Send className="h-4 w-4" />
          Telegram
        </a>
      </div>
    </div>
  );
}
